<p-dialog modal="true" styleClass="atlas-dialog-s" position="top" [closable]="false" [(visible)]="show">
  <ng-template pTemplate="header">
    <h4>{{ 'committees.create.add-a-committee' | translate | titlecase }}</h4>
  </ng-template>
  <form #addForm="ngForm">
    <div
      class="atlas-form mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-justify-start mct-items-center mct-gap-27"
    >
      <div>
        <label>{{ 'committees.create.committee-name' | translate | titlecase }}</label>
        <input name="committeeName" [(ngModel)]="committee.Name" required />
      </div>
      <div>
        <label>{{ 'committees.create.affiliation-code' | translate | titlecase }}</label>
        <p-select
          name="affCode"
          appendTo="body"
          [placeholder]="'common.select-dashes' | translate | titlecase"
          [options]="affCodeItems"
          [(ngModel)]="committee.AffCode"
          required
        ></p-select>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <div class="mct-flex mct-row mct-flex-lt-sm mct-col-lt-sm mct-justify-end mct-items-center mct-gap-10">
      <button type="button" class="atlas-btn atlas-btn-secondary" [disabled]="isSaving" (click)="close()">
        {{ 'common.cancel' | translate | uppercase }}
      </button>
      <button type="button" class="atlas-btn atlas-btn-primary" [disabled]="!addForm.valid" (click)="save()">
        <wl-busy [show]="isSaving"></wl-busy>
        <span [hidden]="isSaving">{{ 'common.save' | translate | uppercase }}</span>
      </button>
    </div>
  </ng-template>
</p-dialog>
